export const DEPRECIATION_METHODS = [
  {
    id: 1,
    label: 'Liniowa',
  },
  {
    id: 2,
    label: 'Degresywna',
    isDisabled: true,
  },
  {
    id: 3,
    label: 'Jednorazowa',
  },
];

export const STATUS_AMORTIZED_ID = 2;
export const STATUS_LIQUIDATED_ID = 3;
export const ACTIVE_SCOPE = {
  id: 1,
  label: 'Aktywny',
};
export const EVIDENCE_SCOPES = [
  {
    id: null,
    label: 'Wszystkie',
  },
  ACTIVE_SCOPE,
  {
    id: STATUS_AMORTIZED_ID,
    label: 'Zamortyzowany',
  },
  {
    id: STATUS_LIQUIDATED_ID,
    label: 'Zlikwidowany',
  },
];
